import React from 'react';
import './Loading.css';

const Loading = ({color}) => {
  return <span className={color === 'green' ? 'loadingComponent green':'loadingComponent black'}></span>;
};

export default Loading;
